/*
     ____        _
    / ___|  ___ | |_   __
    \___ \ / _ \| \ \ / /
     ___) | (_) | |\ V /
    |____/ \___/|_| \_/
    www.solv.no
 */

(function () {
    const feedbackButtons = document.querySelectorAll(".feedback-button");
    if (feedbackButtons.length === 0) return;

    const contentId = document.querySelector(".feedback-content-id-hidden").value;
    const feedbackIdHidden = document.querySelector(".feedback-id-hidden");
    const feedbackSuggestionTextarea = document.querySelector(".feedback-suggestion-textarea");

    const feedbackQuestionPanel = document.querySelector(".feedback-question");
    const feedbackSuggestionPanel = document.querySelector(".feedback-suggestion");
    const feedbackCompletePanel = document.querySelector(".feedback-complete");
    const feedbackErrorPanel = document.querySelector(".feedback-error");
    const feedbackLimitPanel = document.querySelector(".feedback-limit");

    const antiforgeryInput = document.querySelector('input[name="__RequestVerificationToken"]');
    const antiforgeryToken = antiforgeryInput ? antiforgeryInput.value : "";

    const handleError = (error, currentPanel) => {
        currentPanel.style.display = "none";

        if (error.status === 403 && error.responseText === "\"Limit reached\"") {
            // Show the limit panel if the user has reached the feedback limit
            feedbackLimitPanel.style.display = "block";
        } else {
            // Show the error panel if an error occurred
            feedbackErrorPanel.style.display = "block";
        }

        console.error("Error:", error);
    };

    const postAnswer = body => fetch('/api/feedback/AnswerInternal', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': antiforgeryToken
        },
        body: JSON.stringify(body)
    });

    feedbackButtons.forEach(btn => {
        btn.addEventListener("click", async () => {
            try {
                btn.disabled = true; // Disable the button to prevent multiple clicks

                const response = await postAnswer({
                    Id: "",
                    ContentId: contentId,
                    Answer: btn.value,
                    Suggestion: ""
                });

                if (!response.ok) throw response;

                const data = await response.json();

                // Hide the question panel and show the suggestion panel
                feedbackQuestionPanel.style.display = "none";
                feedbackSuggestionPanel.style.display = "block";

                feedbackSuggestionTextarea.focus();
                feedbackIdHidden.value = data.Id;

            } catch (error) {
                handleError(error, feedbackQuestionPanel);
            } finally {
                btn.disabled = false; // Re-enable the button after processing
            }
        });
    });

    const submitButtons = document.querySelectorAll(".feedback-submit-button");

    submitButtons.forEach(btn => {
        btn.addEventListener("click", async () => {
            try {
                btn.disabled = true; // Disable the button to prevent multiple clicks

                const response = await postAnswer({
                    Id: feedbackIdHidden.value,
                    Suggestion: feedbackSuggestionTextarea.value
                });

                if (!response.ok) throw response;

                // Hide the suggestion panel and show the complete panel
                feedbackSuggestionPanel.style.display = "none";
                feedbackCompletePanel.style.display = "block";

            } catch (error) {
                handleError(error, feedbackSuggestionPanel);
            } finally {
                btn.disabled = false; // Re-enable the button after processing
            }
        });
    });
})();
